module.exports = "<div style=\"border: 1px solid red\">reports Component</div>\r\n"